const instruction = [
  {
    label: '1º Grau Incompleto',
    value: 1,
  },
  {
    label: '1º Grau Completo',
    value: 2,
  },
  {
    label: '2º Grau Incompleto',
    value: 3,
  },
  {
    label: '2º Grau Completo',
    value: 4,
  },
  {
    label: 'Superior Incompleto',
    value: 5,
  },
  {
    label: 'Superior Completo',
    value: 6,
  },
  {
    label: 'Superior com Mestrado',
    value: 7,
  },
  {
    label: 'Superior com Especialização',
    value: 8,
  },
  {
    value: 9,
    label: 'Superior com Doutourado',
  },
];

export default instruction;
